import { css } from 'styled-components';

export default css`
  gap: 0;
  margin-top: 10px;
  &.loading-point {
    margin-top: 20px;
  }
  & > * {
    &:not(:last-child) {
      margin-bottom: 10px;
    }
  }

  .comment-section {
    margin-top: 10px;
  }
  .comment-footer {
    display: flex;
    justify-content: flex-end;
    .comment-counter {
      flex: 1;
      text-align: right;
    }
  }
`;
